/*
 * @Date: 2023-04-21 17:11:49
 * @LastEditors: simLarry
 * @LastEditTime: 2023-04-21 17:12:35
 * @FilePath: \P1-M1-QRP-CODE\components\restrict\Header.js
 */
import React from "react";


const Header = () =>{


    return (
        <div className="restrict-head">
            <img src="/static/images/restrict/betway-logo.png" />
        </div>
    )
}

export default Header;